module.exports = __webpack_public_path__ + "img/logo1.61b01613.svg";